export function getErrorTextResponse(response) {
    if (response.error && typeof response.error === 'object') {
        return JSON.stringify(response.error)
    } else if (response.error && response.error !== '') {
        return response.error;
    } else if (response.result && response.result.status === 'operation_fail') {
        if (response.result.message && response.result.message !== '') {
            return response.result.message;
        }
        if (response.result.data && typeof response.result.data === 'object') {
            return JSON.stringify(response.result.data);
        }
        if (response.result.data && typeof response.result.data !== 'object') {
            return response.result.data;
        }
    } else if (response.result.data && response.result.data.status === 'operation_fail') {
        if (response.result.data.message && response.result.data.message !== '') {
            return response.result.data.message;
        }
        if (response.result.data.data && typeof response.result.data.data === 'object') {
            return JSON.stringify(response.result.data.data);
        }
        if (response.result.data.data && typeof response.result.data.data !== 'object') {
            return response.result.data.data;
        }
    }
}
